import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    list(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/locations/${id}/inventories/`,
          timeout: 20000,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    get(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: `${API_BASE}/inventorys/${id}/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    summary(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: `${API_BASE}/inventorys/${id}/summary/?order_by=item_type`,
          params,
          timeout: 30000
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    remaining_summary(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: `${API_BASE}/inventorys/${id}/remaining_summary/?order_by=item_type`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    surplus_summary(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: `${API_BASE}/inventorys/${id}/surplus_summary/?order_by=item_type`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    summary_items(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: `${API_BASE}/inventorys/${id}/items/?order_by=itemType`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    lost_items(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: `${API_BASE}/inventorys/${id}/unchecked_items/?order_by=itemType`,
          params,
          timeout: 50000
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },

    users(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: `${API_BASE}/inventorys/${id}/users/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    createFile(id, progressCallback) {
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "GET",
          url: API_BASE + `/inventorys/${id}/start_csv_creation/`,
          timeout: 20000
        })
      )
        .then(response => {
          const task_id = response.data["task_id"];

          const progressInterval = setInterval(() => {
            axios
              .get(API_BASE + `/file_creation_progress/${task_id}/`)
              .then(progressResponse => {
                const progress = progressResponse.data.progress;
                progressCallback(progress);
                // Update UI with progress (e.g., update progress bar)
                if (progress == 100) {
                  clearInterval(progressInterval);
                  // Once progress reaches 100, initiate file download
                  this.download(id);
                }
              })
              .catch(progressError => {
                console.error("Error fetching progress:", progressError);
                clearInterval(progressInterval);
              });
          }, 2000); // Poll progress every 2 seconds
        })
        .catch(fetchError => {
          console.error("Error fetching progress: ", fetchError);
          throw fetchError;
        });
    },
    download(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "GET",
          url: API_BASE + `/inventorys/${id}/csv/`,
          timeout: 20000
        })
      )
        .then(blob => {
          var binaryData = [];
          binaryData.push(blob.data);
          var url = window.URL.createObjectURL(
            new Blob(binaryData, {
              type: "application/*"
            })
          );
          var a = document.createElement("a");
          a.href = url;
          a.download = `inventory-${id}.csv`;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); // afterwards we remove the element again
        })
        .catch(err => {
          throw err;
        });
    },
    validate(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: `${API_BASE}/inventorys/${id}/`,
          data: {
            state: 2
          }
        })
      )
        .then(response => {
          this.$store.commit("valid", response.data);
          this.$store.commit("loading", false);

          return response;
        })
        .catch(error => {
          throw error;

          // if (error.response === undefined) {
          //   dispatchError(this.$store, 'Error de conexión. Inténtelo más tarde')
          // } else {
          //   dispatchError(this.$store, error.response.data.message)
          //   throw error
          // }
        });
    },
    fileUpload(id, fileData) {
      this.$store.commit("loading", true);
      var formData = new FormData();
      formData.append("file", fileData);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + `/areas/${id}/upload_inventory_file/`,
          data: formData
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },

    unvalidate(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: `${API_BASE}/inventorys/${id}/`,
          data: {
            state: 3
          }
        })
      )
        .then(response => {
          this.$store.commit("valid", response.data);
          this.$store.commit("loading", false);

          return response;
        })
        .catch(error => {
          throw error;

          // if (error.response === undefined) {
          //   dispatchError(this.$store, 'Error de conexión. Inténtelo más tarde')
          // } else {
          //   dispatchError(this.$store, error.response.data.message)
          //   throw error
          // }
        });
    }
  };
};
